<div class="body" @fadeInOut>
    <div class="title">{{"SHARED.DELETEOBJECT.COMPONENT.TITLE" | translate}}</div>
    <div class="box">
        <div class="col-sm-12 box0">
            <div class="text">
                <div class="subtitle">{{deletetitle() | translate}}</div>
                <p>
                    {{"SHARED.DELETEOBJECT.COMPONENT.DELETEZONE" | translate}}
                </p>
                <p><ng-content></ng-content></p>
            </div>
            <div class="buttonzone">
                <button mat-raised-button class="button" (click)="click()">
                    <i class="material-icons">delete_forever</i>
                    <span>{{'SHARED.DELETEOBJECT.COMPONENT.BUTTON.CAPTION' | translate}}</span>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="cancelzone" (click)="clickCancelZone()"></div>